export const captureError = (errorName, error, context = {}) => {
  console.error(`[${errorName}]`, error, context);
  
  if (window.posthog) {
    window.posthog.capture('frontend_error', {
      error_name: errorName,
      error_message: error?.message || String(error),
      error_stack: error?.stack,
      ...context,
      location: window.location.href,
      timestamp: new Date().toISOString(),
    });
  }
};

export const captureException = (error, additionalProperties = {}) => {
  console.error('Exception:', error, additionalProperties);
  
  if (window.posthog) {
    window.posthog.captureException(error, additionalProperties);
  }
};

export const captureApiError = (endpoint, error, statusCode, context = {}) => {
  console.error(`API Error [${endpoint}]:`, error, context);
  
  if (window.posthog) {
    window.posthog.capture('api_error', {
      endpoint,
      error_message: error?.message || String(error),
      status_code: statusCode,
      ...context,
      location: window.location.href,
      timestamp: new Date().toISOString(),
    });
  }
};

export const identifyUser = (userId, userProperties = {}) => {
  if (window.posthog) {
    window.posthog.identify(userId, userProperties);
  }
};

export const trackEvent = (eventName, properties = {}) => {
  if (window.posthog) {
    window.posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  }
};
